export default __webpack_public_path__ + "assets/images/d7f371df541fd30ef0f20539d01f692b.png";